define(function(require, exports, module) {
    'use strict';

    var QuickDepositService = require('modules/cashier/quick-deposit/quick-deposit.service');

    module.exports = new QuickDepositService();
});
